import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { fotosServiciosService, URL_FOTOS } from "../../services/api";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./InfoServicios.css";

// En "contenido", cada string es un párrafo y cada array anidado es una lista de viñetas.
// Para agregar la foto de un servicio: poné el archivo en "public/servicios/"
// y completá el campo "imagen", ej: imagen: "/servicios/soft-gel.jpg".
// Mientras "imagen" esté vacío, se muestra un placeholder.
const _info = [
  {
    icono: "✨",
    titulo: "Extensiones de pestañas",
    clave: "extensiones-pestanas",
    contenido: [
      "Las extensiones de pestañas son una técnica que consiste en colocar fibras sintéticas sobre cada pestaña natural para realzar la mirada de forma personalizada.",
      "Cada diseño se adapta a la forma de tus ojos, la cantidad de pestañas naturales y el efecto que quieras lograr: desde un resultado muy natural hasta una mirada con mayor intensidad.",
      "Olvidate del rímel todos los días y despertate con una mirada lista en todo momento.",
    ],
  },
  {
    icono: "🌿",
    titulo: "Lifting de pestañas + tinte",
    clave: "lifting-tinte",
    contenido: [
      "Si preferís potenciar tus pestañas naturales, el lifting es la opción ideal. El tratamiento eleva, curva y define cada pestaña desde la raíz, generando una sensación de mayor longitud sin necesidad de extensiones.",
      "Además, el tinte intensifica el color para un efecto aún más marcado. El resultado dura aproximadamente entre 6 y 8 semanas.",
    ],
  },
  {
    icono: "💅",
    titulo: "Soft Gel",
    clave: "soft-gel",
    contenido: [
      "Las uñas Soft Gel son extensiones prefabricadas en gel que combinan flexibilidad y rigidez, logrando un acabado natural, liviano y muy resistente.",
      "Para su aplicación, se realiza una preparación cuidadosa de la uña natural, protegiendo la placa ungueal y garantizando una correcta adherencia del producto. Este servicio tiene una duración aproximada de 3 a 4 semanas.",
      "El mantenimiento puede realizarse hasta los 21 días después de la aplicación inicial, y se recomienda hacerlo solo una vez antes del retiro completo.",
      "El tamaño es completamente a elección, ya que se utiliza un tip estándar que se adapta perfectamente a la forma natural de la uña y a las preferencias de cada clienta.",
    ],
  },
  {
    icono: "💖",
    titulo: "Capping",
    clave: "capping",
    contenido: [
      "El capping es una técnica que consiste en fortalecer la uña natural utilizando diferentes materiales según las necesidades de la clienta.",
      "La elección del producto —polygel, gel de construcción o esmalte en gel— depende del tipo de placa ungueal, del nivel de oleosidad de la uña y del largo deseado.",
      "Este proceso permite proteger y endurecer la uña sin necesidad de extensiones, conservando un aspecto natural y prolijo.",
      "Tiene una duración aproximada de 3 semanas, y se recomienda realizar el mantenimiento como máximo a los 21 días para conservar la estructura y el brillo.",
    ],
  },
  {
    icono: "✨",
    titulo: "Esmaltado semipermanente",
    clave: "esmaltado-semipermanente",
    contenido: [
      "El esmaltado semipermanente brinda un acabado brillante y de larga duración sobre la uña natural.",
      "Es una excelente opción para quienes prefieren mantener sus uñas naturales, con color impecable durante varias semanas y sin esperar largos tiempos de secado.",
    ],
  },
  {
    icono: "🤍",
    titulo: "Manicura rusa",
    clave: "manicura-rusa",
    contenido: [
      "Todos los servicios incluyen manicura rusa, una técnica que permite trabajar la uña y la piel con precisión para lograr un acabado limpio y prolijo.",
      "Este procedimiento consiste en:",
      [
        "Pulido suave de la piel que rodea la uña",
        "Corte y limpieza de cutículas sin lastimar",
        "Aplicación de fortalecedor para dar soporte y una terminación perfecta",
        "Definición de la forma de la uña natural según preferencia",
      ],
      "La manicura rusa asegura que el esmaltado quede más prolijo, dure más tiempo y tenga un acabado impecable desde la base hasta la punta ✨💅",
    ],
  },
  {
    icono: "🦶",
    titulo: "Belleza de pies",
    clave: "belleza-pies",
    contenido: [
      "Es un servicio estético que trabaja exclusivamente la parte superficial de las uñas para lograr un acabado limpio y prolijo. No es un procedimiento podológico.",
      "Incluye:",
      [
        "Manicura rusa en los pies: se trabaja únicamente la piel alrededor de la uña y las cutículas, sin intervenir zonas que requieran tratamiento médico.",
        "Definición de la forma de la uña natural para un aspecto parejo y armonioso.",
        "Pulido suave de la superficie para mejorar la adherencia del producto.",
        "Esmaltado semipermanente con acabado brillante y duradero.",
      ],
      "Este servicio es ideal para quienes buscan pies prolijos, uñas cuidadas y un resultado limpio y delicado durante varias semanas. ❤️‍🔥✨",
    ],
  },
  {
    icono: "🌸",
    titulo: "Cejas",
    clave: "cejas",
    proximamente: true,
    contenido: [
      "Muy pronto Glow Room incorporará servicios para realzar tus cejas, incluyendo perfilado, laminado y diseño personalizado, buscando armonizar tu rostro de forma natural.",
    ],
  },
];

const _contenedorInfoGrid = {
  oculto: {},
  visible: { transition: { staggerChildren: 0.05, delayChildren: 0.1 } },
};

const _itemInfoGrid = {
  oculto: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 260, damping: 18 } },
};

function InfoServicios({ abierto, onAbrir, onCerrar }) {
  const [fotosMap, setFotosMap] = useState({});
  const [subiendoClave, setSubiendoClave] = useState(null);
  const _esAdmin = localStorage.getItem("esAdmin") === "true";

  const cargarFotos = async () => {
    try {
      const respuesta = await fotosServiciosService.obtenerTodas();
      const _mapa = {};
      respuesta.data.forEach((f) => {
        _mapa[f.clave] = f.nombreArchivo;
      });
      setFotosMap(_mapa);
    } catch (error) {
      console.error("Error al cargar fotos de servicios", error);
    }
  };

  useEffect(() => {
    cargarFotos();
  }, []);

  const manejarSubida = async (e, clave) => {
    const _archivo = e.target.files[0];
    if (!_archivo) return;
    setSubiendoClave(clave);
    try {
      await fotosServiciosService.subir(_archivo, clave);
      await cargarFotos();
    } catch (error) {
      alert("Error al subir la foto. Probá de nuevo.");
    } finally {
      setSubiendoClave(null);
      e.target.value = "";
    }
  };

  useEffect(() => {
    if (abierto) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    const _cerrarConEsc = (e) => {
      if (e.key === "Escape") onCerrar();
    };
    window.addEventListener("keydown", _cerrarConEsc);
    return () => {
      document.body.style.overflow = "unset";
      window.removeEventListener("keydown", _cerrarConEsc);
    };
  }, [abierto, onCerrar]);

  return (
    <section className="info-servicios" id="info-servicios">
      <AnimarAlScroll>
      <div className="contenedor">
        <button className="info-trigger" onClick={onAbrir}>
          <div className="info-trigger-texto">
            <h3>¿Querés saber más sobre cada servicio?</h3>
            <p>Conocé en qué consiste cada uno antes de reservar.</p>
          </div>
          <span className="info-trigger-accion">Ver información</span>
        </button>
      </div>
      </AnimarAlScroll>

      {abierto && createPortal(
        <motion.div
          className="info-modal-fondo"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={onCerrar}
        >
          <motion.div
            className="info-modal"
            initial={{ scale: 0.96, opacity: 0, y: 16 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.28 }}
            onClick={(e) => e.stopPropagation()}
          >
              <button
                className="info-modal-cerrar"
                onClick={onCerrar}
                aria-label="Cerrar"
              >
                ✕
              </button>

              <div className="info-modal-header">
                <p>Conocé nuestros servicios</p>
                <div className="linea-decorativa"></div>
                <h2>Elegí tu próximo Glow</h2>
              </div>

              <p className="info-servicios-intro">
                Descubrí nuestras opciones de uñas y pestañas y encontrá el
                servicio que mejor se adapte a tu estilo y a lo que estás
                buscando.
              </p>

              <motion.div
                className="info-servicios-grid"
                variants={_contenedorInfoGrid}
                initial="oculto"
                animate="visible"
              >
                {_info.map((item) => (
                  <motion.div
                    key={item.titulo}
                    className={
                      "info-servicios-card" +
                      (item.proximamente ? " proximamente" : "")
                    }
                    variants={_itemInfoGrid}
                  >
                    {(() => {
                      const _fotoUrl = fotosMap[item.clave]
                        ? `${URL_FOTOS}/${fotosMap[item.clave]}`
                        : item.imagen;
                      const _contenidoFoto = _fotoUrl ? (
                        <img src={_fotoUrl} alt={item.titulo} />
                      ) : (
                        <div className="info-card-imagen-placeholder">
                          <span>📷</span>
                          <small>
                            {_esAdmin ? "Subir foto" : "Foto próximamente"}
                          </small>
                        </div>
                      );

                      if (_esAdmin) {
                        return (
                          <label className="info-card-imagen editable">
                            {_contenidoFoto}
                            <span className="info-card-imagen-overlay">
                              {subiendoClave === item.clave
                                ? "Subiendo..."
                                : _fotoUrl
                                ? "✎ Cambiar foto"
                                : "＋ Subir foto"}
                            </span>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => manejarSubida(e, item.clave)}
                              disabled={subiendoClave === item.clave}
                              style={{ display: "none" }}
                            />
                          </label>
                        );
                      }

                      return (
                        <div className="info-card-imagen">{_contenidoFoto}</div>
                      );
                    })()}
                    <h3 className="info-servicios-titulo">
                      {item.titulo}
                      {item.proximamente && (
                        <span className="info-badge-proximamente">
                          Próximamente
                        </span>
                      )}
                    </h3>
                    {item.contenido.map((bloque, i) =>
                      Array.isArray(bloque) ? (
                        <ul key={i} className="info-servicios-bullets">
                          {bloque.map((punto, j) => (
                            <li key={j}>{punto}</li>
                          ))}
                        </ul>
                      ) : (
                        <p key={i} className="info-servicios-texto">
                          {bloque}
                        </p>
                      )
                    )}
                  </motion.div>
                ))}
              </motion.div>

              <p className="info-servicios-nota">
                Todos nuestros servicios cuentan con opción de mantenimiento.
                Ante cualquier duda, escribinos y te asesoramos según lo que
                estés buscando.
              </p>
          </motion.div>
        </motion.div>,
        document.body
      )}
    </section>
  );
}

export default InfoServicios;
